import React, { useState, useEffect } from 'react';
import { useAuth } from '../../../shared/components/auth/withAuth';
import {
  fetchOAuthProviders,
  redirectToOAuthProvider,
  handleOAuthCallback,
} from '../../../utils/auth/oauth';

const LogIn = () => {
  const [ssoProviders, setSsoProviders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const auth = useAuth();

  useEffect(() => {
    if (auth?.isAuthenticated) {
      window.location.href = '/admin/dashboard';
      return;
    }

    const initialise = async () => {
      const callbackResult = await handleOAuthCallback(auth?.signin);
      if (callbackResult.success) return;
      if (callbackResult.error) {
        setError('SSO login failed. Please try again.');
        setLoading(false);
        return;
      }

      // handle Oauth callback returns { success: false, error: null }
      // on first page load so it falls through to this try block
      try {
        const providers = await fetchOAuthProviders();
        setSsoProviders(providers);
      } catch (err) {
        setError('Failed to load authentication providers.');
      }

      setLoading(false);
    };

    initialise();
  }, []);

  if (loading) {
    return (
      <div className="account account--not-photo">
        <div className="account__wrapper">
          <div className="account__card">
            <span className="account__head" />
            <div className="account__btns">
              <div className="text-center">
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="account account--not-photo">
        <div className="account__wrapper">
          <div className="account__card">
            <span className="account__head" />
            <div className="account__btns" style={{ flexDirection: 'column' }}>
              <div className="text-center text-danger mb-3">{error}</div>
              {ssoProviders.length > 0 && (
                <button
                  className="btn btn-primary account__btn"
                  type="button"
                  onClick={() => redirectToOAuthProvider(ssoProviders[0].providerName, ssoProviders[0].providerId)}
                >
                  {ssoProviders[0].loginButtonText}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }

  if (ssoProviders.length === 0) {
    return (
      <div className="account account--not-photo">
        <div className="account__wrapper">
          <div className="account__card">
            <span className="account__head" />
            <div className="account__btns">
              <div className="text-center">No authentication providers configured</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="account account--not-photo">
      <div className="account__wrapper">
        <div className="account__card">
          <span className="account__head" />
          <div className="account__btns" style={{ flexDirection: 'column' }}>
            {ssoProviders.map(provider => (
              <button
                key={provider.providerId}
                className="btn btn-primary account__btn"
                type="button"
                onClick={() => redirectToOAuthProvider(provider.providerName, provider.providerId)}
              >
                {provider.loginButtonText}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LogIn;
